document.addEventListener('DOMContentLoaded', () => {
  const cards = [...document.querySelectorAll('[data-pdp-ht-card]')];
  if (!cards.length) return;

  const modal     = document.querySelector('[data-pdp-ht-modal]');
  if (!modal) return;

  const modalTitle = modal.querySelector('[data-pdp-ht-modal-title]');
  const modalDesc  = modal.querySelector('[data-pdp-ht-modal-desc]');

  const closeModal = () => {
    modal.removeAttribute('data-open');
    document.documentElement.classList.remove('overflow-hidden');
  };

  cards.forEach(card => {
    card.addEventListener('click', () => {
      const { title, description } = card.dataset;
      if (!description) return;
      if (modalTitle) modalTitle.textContent = title;
      if (modalDesc)  modalDesc.textContent  = description;
      modal.setAttribute('data-open', '');
      document.documentElement.classList.add('overflow-hidden');
    });
  });

  document.addEventListener('click', ({ target }) => {
    if (target.closest('[data-pdp-ht-overlay]') || target.closest('[data-pdp-ht-close]')) {
      closeModal();
    }
  });
});
